import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { useStyles } from "./FriendEmpty.style";
import { useTranslation } from "react-i18next";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import Button from "../../core/Button/Button";
import { useAppSelector } from "../../hooks";
import { useShareUser } from "../../../hooks/resolvers/friend/friend";

export const FriendEmpty: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const classes = useStyles();
  const { ...othersProps } = props;
  const { t } = useTranslation();
  const { friendActiveTab } = useAppSelector((state) => state.friends);
  const onInviteFriends = useShareUser();

  const getEmptyFriendText = () => {
    if (friendActiveTab?.includes("Following")) {
      return {
        title: "friend_You’re not following anyone",
        description:
          "friend_You can also invite your friends through social media",
      };
    } else {
      return {
        title: "friend_You don’t have any followers",
        description:
          "friend_You can also invite your friends through social media",
      };
    }
  };

  if (friendActiveTab?.includes("Suggestions")) return null;

  return (
    <div {...othersProps} className={clsx(classes.root, othersProps.className)}>
      <Typography variant={TypographyVariant.HeadingH5Bold}>
        {t(getEmptyFriendText().title)}
      </Typography>
      <Typography
        variant={TypographyVariant.BodyB5Regular}
        className={classes.desc}
      >
        {t(getEmptyFriendText().description)}
      </Typography>
      <Button size="small" className={classes.btn} onClick={onInviteFriends}>
        {t("friend_Invite friends")}
      </Button>
    </div>
  );
};
